module.exports = flarum.extensions['askvortsov-rich-text'];